import {BaseContextMessageHandler, HostedComponent} from "../../common";
import {ShadowRootRef} from "../shadowRootRef";
import {BaseMyopMessage, MyopBindMessage} from "../../messages";

export type MessageToHost = (message: BaseMyopMessage) => void

export abstract class BaseWebComponentMessageHandler<T extends BaseMyopMessage = any> extends BaseContextMessageHandler<T, Record<string, HostedComponent<ShadowRootRef>>> {

    abstract messageType: string

    constructor(messageToHost: any, public context: Record<string, HostedComponent<ShadowRootRef>>) {
        super(messageToHost);
    }

    abstract innerExecutor: (event: T, shadowRootRef: ShadowRootRef, messageToHost: MessageToHost) => void;

    executor = (event: T) => {
        //debugger;
        if (event.destination) {
            const destination = event.destination;
            if (this.context[destination].context) {

                // patch the source id, think about that ?
                const _messageToHost = (message: BaseMyopMessage, replayTo?: MyopBindMessage) => {
                    this.messageToHost({
                        ...message,
                        source: event.destination ? event.destination : event.source,
                        destination: event.source ? event.source : event.destination
                    } as BaseMyopMessage, replayTo)
                }

                return this.innerExecutor(event, this.context[destination].context, _messageToHost);
            } else {
                debugger;
            }
        } else {
            debugger;
        }
    }
}
